import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ActiveAuthorizationResponse } from '../../types/server-types';
import { CacheKeys } from './cache-configuration';
import { http } from '../http';

/**
 * Whether the location offers "reserve funds on card" and the user's
 * currently active reservation there (null when none).
 */
export const useActiveAuthorization = (
  locationId: number | undefined,
): UseQueryResult<ActiveAuthorizationResponse> => {
  return useQuery({
    queryKey: [CacheKeys.ACTIVE_AUTHORIZATION, locationId],
    queryFn: () => http.getActiveAuthorization(locationId as number),
    enabled: !!locationId,
    refetchInterval: 15000,
  });
};
